import { vTooltip } from 'floating-vue'

// v-tooltip: Displays a popover on hovered element.
//
// NOTE: Corporate is already using this so might as well use it for consumer too
export default vTooltip
